import { Row, Col, Card, Statistic, notification } from 'antd';
import pagination from 'antd/lib/pagination';
import { FC, useEffect, useState } from 'react';
import restful from '../../restful';

type Balance = {
    status: string;
    balance: string;
    currency: string;
}
const YassicialBalance: FC = () => {

    const [isLoaded, setIsLoaded] = useState<boolean>(false);
    const [balance, setBalance] = useState<Balance>({
        status: "success",
        balance: "0",
        currency: "IRT",
    });

    const fetchData = () => {
        setIsLoaded(true);
        restful.get(`/yassocial/balance`)
            .then((res) => {
                setBalance(res.data.result);
            })
            .catch((error) => {
                return notification.error({
                    message: 'Error ' + error.statusCode,
                    description: error.message,
                });
            })
            .finally(() => { setIsLoaded(false) })
    };

    useEffect(() => {
        fetchData();
    }, [])

    return (
        <Card>
            <Statistic title="اعتبار یاس سوشیال"  loading={isLoaded} value={parseInt(balance.balance)} suffix={balance.currency} />
        </Card>
    );
}

export default YassicialBalance;
